import React from 'react';
import { AmrSearchFiltersComponent } from './amr/amr-search-filters.component';
import { CtSearchFiltersComponent } from './ct/ct-search-filters.component';
import { PicoSearchFiltersComponent } from './pico/pico-search-filters.component';
import { SearchFiltersContainerComponent } from './search-filters-container.component';
import { SearchResultsComponent } from '../search-results.component';
import { SearchTabEnum } from '@vivli/features/search/infrastructure/enum';
import { useAssignedAppTypeContext, useSearchApiContext } from '@vivli/core/infrastructure/context';

export const SearchFiltersComponent = () => {
    const { isAmr } = useAssignedAppTypeContext();
    const { isShowingResults, activeTab } = useSearchApiContext();

    const getActiveFilters = () => {
        if (isAmr) {
            return <AmrSearchFiltersComponent />;
        }

        switch (activeTab) {
            case SearchTabEnum.FirstTab:
                return <CtSearchFiltersComponent />;
            case SearchTabEnum.SecondTab:
                return <PicoSearchFiltersComponent />;
        }
    };

    return (
        <SearchFiltersContainerComponent>
            {getActiveFilters()}
            <SearchResultsComponent isOpen={isShowingResults} />
        </SearchFiltersContainerComponent>
    );
};
